export default __webpack_public_path__ + "static/media/foto2.76d47c79.jpg";